/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_No_ChangesInputs */

const en_us2_draft_no_changes = /** @type {(inputs: Draft_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This draft is the same as your current plan.`)
};

const pt_br2_draft_no_changes = /** @type {(inputs: Draft_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este rascunho é igual ao seu plano atual.`)
};

const es_419_draft_no_changes = /** @type {(inputs: Draft_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este borrador es igual a tu plan actual.`)
};

const pt_pt2_draft_no_changes = /** @type {(inputs: Draft_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este rascunho é igual ao teu plano atual.`)
};

const fr_fr2_draft_no_changes = /** @type {(inputs: Draft_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce brouillon est identique à ton programme actuel.`)
};

const de_de2_draft_no_changes = /** @type {(inputs: Draft_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Entwurf ist identisch mit deinem aktuellen Plan.`)
};

const it_it2_draft_no_changes = /** @type {(inputs: Draft_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa bozza è uguale alla tua scheda attuale.`)
};

/**
* | output |
* | --- |
* | "This draft is the same as your current plan." |
*
* @param {Draft_No_ChangesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_no_changes = /** @type {((inputs?: Draft_No_ChangesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_No_ChangesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_no_changes(inputs)
	if (locale === "es-419") return es_419_draft_no_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_no_changes(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_no_changes(inputs)
	if (locale === "de-DE") return de_de2_draft_no_changes(inputs)
	if (locale === "it-IT") return it_it2_draft_no_changes(inputs)
	return en_us2_draft_no_changes(inputs)
});
export { draft_no_changes as "draft.no_changes" }